import { ConversationStep, Theme } from "../../interfaces";
import AppointmentSteps from "../AppointmentSteps";
import DefaultSteps from "../DefaultSteps";
import ModifiedSimpleSteps from "../full/ModifiedSimpleSteps";

import IllustrationPage from "../../components/custom/IllustrationPage";
import EscalationSteps from "../EscalationSteps";

const ShortFlow = (theme: Theme) => {
    return [
        {
            id: "video_greeting",
            video: `${process.env.REACT_APP_COMMS_URL}/download/files/public/CaC83633-3a77-4667-25C3-2C7871586038.mp4`,
            type: "bot",
            trigger: "1",
        },
        {
            id: "1",
            type: "bot",
            message: "Hey! 👋",
            trigger: "2",
        },
        {
            id: "2",
            type: "bot",
            message: "My name is <strong>Parker</strong> - I'm an AI Mortgage Assistant.",
            trigger: "mortgage_applicant",
        },
        {
            id: "loading_illustration",
            type: "bot",
            // video:
            //   `${process.env.REACT_APP_COMMS_URL}/download/files/public/1158m906-5m0m-4198-9o88-19861ro51186.mp4`,
            message: "Please wait while we scan the market...",
            trigger: "illustration_page",
        },
        {
            id: "illustration_page",
            type: "bot",
            trigger: "after_illu_video",
            component: <IllustrationPage />,
        },
        {
            id: "after_illu_video",
            type: "bot",
            video: `${process.env.REACT_APP_COMMS_URL}/download/files/public/88777r71-45r6-4166-8o54-85818151586m.mp4`,
            trigger: "talk_with_advisor",
        },
        ...ModifiedSimpleSteps(theme),
        ...DefaultSteps(theme),
        ...AppointmentSteps(theme),
        ...EscalationSteps,
    ] as ConversationStep[];
};

export default ShortFlow;
